export function setActiveWidget(id, widget) {
  return {
    type: 'SET_ACTIVE_WIDGET',
    payload: {
      id,
      widget,
    },
  }
}
